<template>
  <div class="tableContainer">
    <!--#region order table  -->
    <orders-table
      @paginate="getFailedOrders"
      @orderReProcessed="orderReProcessed"
      :paginationInfo="paginationInfo"
      :isLoading="isLoading"
      :orders="failedOrders"
    ></orders-table>
    <!--#endregion -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PaginatedApiModel } from '../models/api/response';
import { OrderClientModel } from '../models/client';
import { orderService } from '../services';
import { ElNotification } from 'element-plus';
import OrdersTable from './orders-table.vue';

export default defineComponent({
  name: 'failed-shipment-table',
  components: {
    OrdersTable,
  },
  emits: ['orderReProcessed'],
  data: function () {
    return {
      isLoading: false,
      updatingOrders: {},
      failedOrders: [] as OrderClientModel[],
      paginationInfo: null as PaginatedApiModel<OrderClientModel> | null,
      total: 10,
    };
  },
  async created() {
    await this.getFailedOrders();
  },
  methods: {
    orderReProcessed() {
      this.$emit('orderReProcessed');
    },
    async getFailedOrders(page = 1) {
      this.isLoading = true;
      try {
        const response = await orderService.getOrders({
          page,
          total: this.total,
          status: 'submission_error',
        });
        this.failedOrders = response.data;
        if (!this.failedOrders.length && page != 1) {
          await this.getFailedOrders(page - 1);
          return;
        }
        this.paginationInfo = response;
      } catch (e) {
        // 401 error will be handled by response interceptor
        if (e.response.status !== 401) {
          ElNotification({
            title: 'Error',
            type: 'error',
            message: 'Failed to load requested data. Please try again later.',
            position: 'bottom-right',
          });
        }
      }
      this.isLoading = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.tableContainer ::v-deep(tr) {
  cursor: pointer;
  text-transform: capitalize;
}

.action-icons:hover {
  margin-top: -1px;
}
</style>
